import { render, staticRenderFns } from "./BulkPayment.vue?vue&type=template&id=13405e6e&"
import script from "./BulkPayment.vue?vue&type=script&lang=ts&"
export * from "./BulkPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports